import { render, staticRenderFns } from "./tickets-table.vue?vue&type=template&id=2b8c809e"
import script from "./tickets-table.vue?vue&type=script&lang=js"
export * from "./tickets-table.vue?vue&type=script&lang=js"
import style0 from "./tickets-table.vue?vue&type=style&index=0&id=2b8c809e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports